import { render } from "./FooterSocialMedia.vue?vue&type=template&id=b03b8a48&scoped=true&ts=true"
import script from "./FooterSocialMedia.vue?vue&type=script&lang=ts"
export * from "./FooterSocialMedia.vue?vue&type=script&lang=ts"

import "./FooterSocialMedia.vue?vue&type=style&index=0&id=b03b8a48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b03b8a48"]])

export default __exports__